import { AddIcon, Button, ErrorOutlineOutlinedIcon, Flex, Text } from '@shared/components';

export function EmptyPartSection() {
  return (
    <Flex
      sx={(theme) => ({
        py: theme.spacing(4),
        gap: theme.spacing(4),
        border: '1px solid',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: theme.shape.rounded(2),
        borderColor: theme.palette.grey[300],
      })}
    >
      <ErrorOutlineOutlinedIcon
        sx={{
          fontSize: 48,
          color: (theme) => theme.palette.grey[400],
        }}
      />
      <Text
        variant='h5'
        sx={{
          fontSize: 18,
          fontWeight: 600,
          color: (theme) => theme.palette.text.secondary,
        }}
      >
        ยังไม่มีหมวดในคลังข้อสอบนี้
      </Text>
      <Button size='small' variant='outlined' color='secondary' startIcon={<AddIcon />}>
        Add Part
      </Button>
    </Flex>
  );
}
